import React from 'react';
import styled from 'styled-components';
import { marquee as marqueeKeyframes } from '../animations';
import { marquee as words } from '../content';

const Bar = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.line};
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  padding: 22px 0;
  overflow: hidden;
  white-space: nowrap;
`;

const Track = styled.div`
  display: inline-flex;
  animation: ${marqueeKeyframes} 34s linear infinite;
  will-change: transform;
`;

const Group = styled.span`
  display: inline-flex;
  align-items: center;
`;

const Word = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 26px;
  padding: 0 26px;
  font-size: clamp(1.4rem, 3vw, 2.4rem);
  font-weight: 600;
  letter-spacing: -0.01em;
`;

const Slash = styled.span`
  font-family: ${({ theme }) => theme.fonts.serif};
  font-style: italic;
  color: ${({ theme }) => theme.colors.accent};
`;

const WordList: React.FC<{ duplicate?: boolean }> = ({ duplicate }) => (
  <Group aria-hidden={duplicate || undefined}>
    {words.map(word => (
      <Word key={word}>
        {word}
        <Slash aria-hidden>/</Slash>
      </Word>
    ))}
  </Group>
);

/** Two identical runs of the word list, so translating the track by half loops seamlessly. */
const Marquee: React.FC = () => (
  <Bar>
    <Track>
      <WordList />
      <WordList duplicate />
    </Track>
  </Bar>
);

export default Marquee;
